import { BRAND, INSTAGRAM } from "../../data/content";
import { Reveal, Btn } from "../shared";
import { Instagram } from "lucide-react";

export default function InstagramFeed() {
  return (
    <section className="bg-ivory py-24 md:py-32" data-testid="instagram-section">
      <div className="mx-auto max-w-7xl px-6 md:px-12">
        <div className="text-center">
          <Reveal>
            <p className="text-[11px] uppercase tracking-[0.3em] text-gold-text">Instagram</p>
            <h2 className="mt-4 font-serif text-4xl md:text-6xl text-emerald leading-[1.05]">
              Follow <span className="italic">The Big Wedd</span>
            </h2>
            <p className="mt-4 text-sm text-stone2">More weddings. More ideas. More behind-the-scenes moments.</p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
          {INSTAGRAM.map((src, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <a
                href={BRAND.instagram}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`instagram-tile-${i}`}
                className="group relative block aspect-square overflow-hidden"
              >
                <img src={src} alt="The Big Wedd on Instagram" loading="lazy" className="h-full w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-105" />
                <div className="absolute inset-0 flex items-center justify-center bg-emerald/0 opacity-0 transition-all duration-500 group-hover:bg-emerald/60 group-hover:opacity-100">
                  <Instagram className="h-7 w-7 text-ivory" />
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2} className="mt-12 text-center">
          <Btn href={BRAND.instagram} external variant="emerald" testid="instagram-cta">Follow Us On Instagram</Btn>
        </Reveal>
      </div>
    </section>
  );
}
